'use strict';

const processInclude = require('base/util');
const clientSideValidation = require('core/components/clientSideValidation');
$(document).ready(function () {
  processInclude(require('core/components/helpNavigation.js'));
  processInclude(require('core/components/helpSearch.js'));
  processInclude(require('core/components/helpForms.js'));
  processInclude(require('tealium/tealiumEvents'));
  // processInclude(require('core/components/helpAssets.js'));
  //giftCard.handleGifcardComponent();
  clientSideValidation.noBubbleEvents();
});
require('core/components/spinner');
